module.exports = "<p>\n  not-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/not-found/not-found.component.html
// module id = 746
// module chunks = 1